import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import PublicHome from "@/pages/PublicHome";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MasterDashboard from "@/pages/MasterDashboard";
import ClubDashboard from "@/pages/ClubDashboard";
import PublicSchoolMembers from "@/pages/PublicSchoolMembers";

const Protected = ({ role, children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Učitavanje...</div>;
  if (!user) return <Navigate to="/prijava" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "master" ? "/master" : "/klub"} replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicHome />} />
          <Route path="/skola/:clubId" element={<PublicSchoolMembers />} />
          <Route path="/prijava" element={<Login />} />
          <Route path="/registracija" element={<Register />} />
          <Route path="/master" element={<Protected role="master"><MasterDashboard /></Protected>} />
          <Route path="/klub" element={<Protected role="club"><ClubDashboard /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </AuthProvider>
  );
}

export default App;
